import { Injectable } from '@angular/core';
import { FeathersServiceClass } from '@fire/feathers';
import { FeathersAppService } from '@fire/feathers';
import { fireLogger } from '../../core/utils/fire-logger';
import { FeathersConnectionNames } from '../../core/config/feathers-connection-names';



@Injectable()
export class WidgetService extends FeathersServiceClass {



  constructor(
    feathersAppService:FeathersAppService,
  ) {
    super(feathersAppService);
    fireLogger.log('initializing widget service --- CONSTRUCTOR');

    this.init(FeathersConnectionNames.Main, {
      serviceName: 'widgets',
    });
  }






}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/services/widget.service.ts